import React, { useRef, useEffect, useState } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';

const QrModal = ({ triggerID, onClose, onScan }) => {
    const modalRef = useRef(null);
    const html5QrCodeRef = useRef(null);
    const [cameras, setCameras] = useState([]);
    const [selectedCamera, setSelectedCamera] = useState(null);

    const handleScan = (decodedText, decodedResult) => {
        console.log(decodedText, decodedResult);
        onScan(decodedText);
        close();
    };

    const handleError = (errorMessage) => {
        console.error(errorMessage);
    };

    const stopScanner = async () => {
        if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) {
            try {
                await html5QrCodeRef.current.stop();
                html5QrCodeRef.current.clear();
            } catch (error) {
                console.error("Error stopping the scanner:", error);
            }
        }
    };
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .modal-content select {
                padding: 5px;
                font-size: 16px;
                border-radius: 5px;
                border: 1px solid #ccc;
                margin-right: 10px;
            }
          
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);
    const startScanner = async (cameraId) => {
        if (!html5QrCodeRef.current) {
            html5QrCodeRef.current = new Html5Qrcode("qr-reader");
        }

        const config = {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
        };

        try {
            await html5QrCodeRef.current.start(cameraId, config, handleScan, handleError);
        } catch (error) {
            console.error("Error starting the scanner:", error);
        }
    };

    const close = async () => {
        await stopScanner();
        html5QrCodeRef.current = null;
        onClose();
    };

    useEffect(() => {
        Html5Qrcode.getCameras().then(camerasList => {
            if (camerasList.length > 0) {
                setCameras(camerasList);
                setSelectedCamera(camerasList[0].id);
            }
        }).catch(err => console.error("Error getting cameras:", err));
    }, []);

    useEffect(() => {
        const switchCamera = async () => {
            if (selectedCamera) {
                await stopScanner();
                startScanner(selectedCamera);
            }
        };
        switchCamera();
    }, [selectedCamera]);

    return (
        <div id={triggerID} ref={modalRef} className="modal">
            <div className="modal-content">
                <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>

                    <button className="close-button-qr" onClick={close}>x</button>


                    {cameras.length > 0 && (
                        <select
                            style={{ padding: '0px', width: 'auto', height: 'auto' }}
                            onChange={(e) => setSelectedCamera(e.target.value)}
                            value={selectedCamera}
                        >
                            {cameras.map((camera) => (
                                <option key={camera.id} value={camera.id}>
                                    {camera.label || `Camera ${camera.id}`}
                                </option>
                            ))}
                        </select>

                    )}
                    <h2>Scan your QR-Code</h2>
                </div>
                <div id="qr-reader" style={{ width: '100%' }}></div>
            </div>
        </div>
    );
};

export default QrModal;
